import { Fragment } from 'react';
import compact from 'lodash/compact';

function guestItem(count, singular, plural) {
  if (!count || count < 1) {
    return;
  }
  return count > 1 ? `${count} ${plural}` : `1 ${singular}`;
}

const Occupants = ({ numberOfAdults, numberOfChildren, numberOfInfants }) => {
  const guests = [
    guestItem(numberOfAdults, 'adult', 'adults'),
    guestItem(numberOfChildren, 'child', 'children'),
    guestItem(numberOfInfants, 'infant', 'infants'),
  ];
  return <Fragment>{compact(guests).join(', ')}</Fragment>;
};

export default Occupants;
